<template>
<div class="selected-pricing-container">
    <span class="font-C-selected-pricing-container">Selected plan:</span><span class="font-D-container">
        
    </span>
</div>
</template>

<script>

export default {
  name: "SelectedPricingContainer"
}

</script>

<style scoped>

</style>